import React, { FC } from 'react';
import styles from './ActionContainer.module.scss';

interface ActionContainerProps {
	children: JSX.Element | JSX.Element[];
}

const ActionContainer: FC<ActionContainerProps> = ({ children }): JSX.Element => {
	return <section className={styles.ActionContainer}>{children}</section>;
};

export { ActionContainer };
